//@ts-ignore
import { CLESSON_MODES } from '@yandex-int/k-common/constants';
import b from 'b_';
import { SimpleCallback } from 'platform-components';
import React from 'react';

import AssignLessonPanel from 'common.components/lesson-view.assignment/assignment';
import ScrollBlock from 'common.components/scroll-block/scroll-block';

import ActionButton from '../__action-button/side-panel__action-button';
import AssignHeaderDesktop from '../__assign-header/side-panel__assign-header_desktop';
import AssignHeaderMobile from '../__assign-header/side-panel__assign-header_mobile';
import { Controls } from '../__controls/side-panel__controls';
import { SidePanelFooter } from '../__footer/side-panel__footer';
import { SidePanelHeader } from '../__header/side-panel__header';

interface Props {
    clessonMode: CLESSON_MODES | null;
    isMobile: boolean;
    isExpanded: boolean;
    onForceComplete?: SimpleCallback;
    isCopyingEnabled?: boolean;
}

export const SidePanelModeAfterCopying = (props: Props) => {
    const { clessonMode, isMobile, isExpanded, onForceComplete, isCopyingEnabled } = props;
    const shouldFillDates = clessonMode === CLESSON_MODES.LESSON;

    return (
        <>
            <SidePanelHeader isExpanded={isExpanded}>
                {isMobile ? <AssignHeaderMobile /> : <AssignHeaderDesktop />}
            </SidePanelHeader>
            <ScrollBlock mix={b('side-panel', 'scroll-block', { expanded: isExpanded })}>
                <div className="side-panel__content">
                    <AssignLessonPanel shouldFillDates={shouldFillDates} />
                </div>
            </ScrollBlock>
            <SidePanelFooter>
                <div className="side-panel__footer-controls">
                    <ActionButton onForceComplete={onForceComplete} />
                    <Controls isCopyingEnabled={isCopyingEnabled} isMobile={isMobile} />
                </div>
            </SidePanelFooter>
        </>
    );
};
